export const en = {
  core: {
    pageTitle: 'Components Library',
    dialogContacts: {
      title: 'Book a consultation',
      description:
        'One of our experts will contact you shortly to provide more information about the plan you are interested in or to make changes.',
      modes: {
        contactMe: {
          label: 'Contact me',
          description:
            'Check the details that will be used to contact you before sending the request.',
        },
        contactOther: {
          label: 'Contact another person',
          description: 'Enter the details of the person to be contacted.',
        },
      },
      contactMe: {
        header: 'Your details',
      },
      contactOther: {
        header: 'Contact person details',
      },
      fields: {
        firstName: 'First name',
        firstNamePlaceholder: 'E.g.: John',
        lastName: 'Last name',
        lastNamePlaceholder: 'E.g.: Doe',
        email: 'Email',
        emailPlaceholder: 'E.g.: john.doe@email.com',
        phone: 'Phone',
        phonePlaceholder: 'E.g.: +1 555 123 4567',
        messageOptional: 'Message (optional)',
        messagePlaceholder: 'e.g.: I would like to discuss a custom offer',
      },
      buttons: {
        cancel: 'Cancel',
        send: 'Send',
      },
      success: {
        title: 'Request sent successfully!',
        description: 'We have received your contact request.',
        close: 'Close',
        cta: 'Back to Homepage',
      },
      error: {
        title: 'Oops, something went wrong!',
        description:
          'We could not send your request. Please check the details entered and try again. If the problem persists, wait a few minutes and try again later.',
        close: 'Close',
        retry: 'Retry',
      },
    },
  },
};
